/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Hier werden die Produkte in einer liste angezeigt. Pro Zeile
 * wird immer nur ein einziges Produkt angezeigt. Hier im 
 * ProduktControllerAdmin können die Produkte auch verwaltet werden.
 * Produkte können hier erfasst, gelöscht oder verschoben werden. 
 * 
 * Wählt der Benutzer hier eine Produktkarte aus, so wird das 
 * vollständige Produkt mittels der Komponente ProdukctLandscape.js
 * oder ProduktPortrait.js angezeigt. 
 * 
 * Der ProductControllerUser ist verwand mit diesem ProductControllerAdmin.
 * Der ProductControllerUser wird im User-Modus angezeigt.  
 * Der ProductControllerAdmin wird im Admin-Modus angezeigt, nur hier kann 
 * auch die Reihenfolge der dargestellten Produkte verändert werden.
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";


import * as utils from "../../../basics/utils";
import { Icon } from '../../partials/Icons';
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";

import ProductDetails from "./ProductDetails";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

class ProductControllerAdmin extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.agGridRightApi = null;
        this.agGridRightColumnApi = null;
        this.agGridRightWidth = 200;
        this.agGridRightVisibleItems = 5;

        this.agGridRowHeight = 200;
        this.agGridHeaderHeight = 0;

        this.timestamp = 0;

        this.productList = [];

    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, unitHeight, windowWidth, headerHeight, path, orientation, appModus } = this.props.app;

        const itemWidth = (orientation === 'landscape') ? windowWidth / 6.5 : windowWidth / 4.7;
        const itemHeight = itemWidth * 1.25;

        this.agGridRightWidth = itemHeight;

        const dialog = utils.getDialogByPath(path);

        const node = utils.getTreePortfolio(dialog.portfolio + '/' + dialog.groups, true);
        if (node === null) return null;

        const sequence = utils.getSequence(dialog.portfolio + '/' + dialog.groups);

        this.productList = [];
        if (sequence) {
            sequence.forEach((productName) => {
                const productFiltered = node.filter(f => f.name === productName);

                if (productFiltered.length > 0) this.productList.push(productFiltered[0]);
            })
        } else {
            node.forEach((d) => {
                this.productList.push(d);
            });
        }
        this.productList.push({ name: '_NEW', path: null });

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderList = () => {

            // Allgemeine AG-Grid Konfiguration
            const defaultColDef = {
                sortable: false,
                editable: false,
                filter: false,
                resizable: false,
                enableValue: false,
                enableRowGroup: false,
                enablePivot: false
            }

            // Spalten konfigurieren    
            const columnsDefsRight = [
                {
                    headerName: "",
                    field: "drag",
                    width: this.agGridRightWidth * .0,
                    rowDrag: true,
                },
                {
                    headerName: "",
                    field: "name",
                    width: this.agGridRightWidth * .4,
                    rowDrag: false,
                    cellRenderer: "textRenderer",
                },
                {
                    headerName: "",
                    field: "path",
                    width: this.agGridRightWidth * .2,
                    cellRenderer: "imageRenderer",
                },
                {
                    headerName: "",
                    field: "path",
                    width: this.agGridRightWidth * .4,
                    cellRenderer: "propertiesRenderer",
                },
                {
                    headerName: "",
                    field: "action",
                    width: this.agGridRightWidth * .2,
                    cellRenderer: "actionRenderer",
                }
            ];

            // Inizalisierung
            const onGridRightReady = (params) => {
                this.agGridRightApi = params.api;
                this.agGridRightColumnApi = params.columnApi;
                params.api.sizeColumnsToFit();
            }

            // callbacks
            const onChange = (d) => {
                console.log('onChange(X)', d);
            }

            const onRowDragEnd = () => {
                console.log('onRowDragEnd()');
                let reorderList = [];
                this.agGridRightApi.forEachNode((d) => {
                    if (d.data.name !== '_NEW') {
                        reorderList.push(d.data.name);
                    }
                });

                this.props.uploadJSON(path, 'sequence.json', reorderList, () => {
                    console.log('uploadJSON(success)');
                    this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio + '/' + dialog.groups);
                }, (error) => {
                    console.log('uploadJSON(error)', error);
                });
            }

            const onCellClicked = (event) => {
                if (event.column.colId !== 'action') return;

                const d = this.productList[event.rowIndex];

                this.props.setPath(dialog.portfolio + '/' + dialog.groups + '/' + d.name);
                this.props.setCurrentProduct(d);
            }

            const renderText = (d) => {

                const style = { minHeight: this.agGridRowHeight };

                if (d.data.name === '_NEW') {
                    const onClick = () => {
                        console.log('onClick(ProductControllerAdmin) path:', path);
                        this.props.setModalDialog('ProductModal', 'create');
                    }


                    return (
                        <div className="flex flex-col text-start justify-center text-gray-400 text-8xl" onClick={onClick} style={{ ...style }}>
                            <div>＋</div>
                        </div>
                    )
                }

                return (
                    <div className="flex items-center justify-start text-xl font-bold text-gray-900 " style={style}>{d.data.name}</div>
                )
            }

            const renderImage = (d) => {
                if (d.data.name === '_NEW') return null;

                const image = utils.getProductImage(d.data.children, path + '/' + d.data.name, 'free');
                const style = { minHeight: this.agGridRowHeight, ...utils.getStyleBackgroundURL(image.url, '100%', '100%') };

                return (
                    <div className="flex justify-center w-full text-center font-bold text-gray-900" style={style}></div>
                )
            }

            const renderProperties = (d) => {
                if (d.data.name === '_NEW') return null;

                const style = { minHeight: this.agGridRowHeight };

                return (
                    <div className="flex items-center justify-center" style={style}>
                        <ProductDetails node={d.data} height={this.agGridRowHeight * .15} version='center' />
                    </div>
                )
            }

            const renderAction = (d) => {
                if (d.data.name === '_NEW') return null;

                const style = { minHeight: this.agGridRowHeight };

                return (
                    <div className="flex items-center justify-center text-center text-2xl font-bold text-gray-900" style={style}>
                        <Icon type='edit2' width={unitHeight * .4} height={unitHeight * .4} />
                    </div>
                )
            }

            // ###############################################################
            // renderDetailList()
            // ###############################################################
            const height = this.agGridRightVisibleItems * this.agGridRowHeight + this.agGridHeaderHeight + 1;

            this.timestamp = new Date().getTime();

            return (
                <div key={this.timestamp} className="w-3/4 ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="adminProducts"
                        onGridReady={onGridRightReady}

                        // General definitions
                        sideBar={false}

                        // Column
                        columnDefs={columnsDefsRight}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={this.productList}
                        rowHeight={this.agGridRowHeight}
                        rowSelection={"single"}
                        rowMultiSelectWithClick={false}
                        onRowDragEnd={onRowDragEnd}
                        onCellValueChanged={onChange}
                        rowDragManaged={true}
                        onCellClicked={onCellClicked}

                        // Header
                        headerHeight={this.agGridHeaderHeight}

                        // Pagination
                        pagination={false}
                        paginationAutoPageSize={false}
                        suppressScrollOnNewData={false}

                        // Editing
                        singleClickEdit={false}

                        // cell renderer
                        frameworkComponents={{
                            propertiesRenderer: renderProperties,
                            textRenderer: renderText,
                            imageRenderer: renderImage,
                            actionRenderer: renderAction
                        }}
                    />
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================        

        const style = {
            top: headerHeight + 'px',
            left: (orientation === 'landscape') ? '20%' : '25%',
            height: inputHeight + 'px',
            minHeight: inputHeight + 'px'
        };

        if (dialog.groups === '') return null; // wenn noch keine Gruppe ausgewählt wurde.

        if (dialog.product !== '') return null; // wenn eine Gruppe aber noch kein Produkt ausgewählt wurde. 

        if (appModus !== 'Admin') return null;

        return (
            <div className="absolute w-full h-full p-2 items-center bg-forsales-gray overflow-y-auto z-20" style={style}>
                {renderList()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductControllerAdmin);
